module.exports = __webpack_public_path__ + "img/4.e71369e8.png";